// extracted by mini-css-extract-plugin
module.exports = {"main-container":"PageContent_main-container__7FsKY","child-container":"PageContent_child-container__OtfeG"};